import { Button, Card, Form, Input, notification, Select, Typography } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { TargetOs } from '@/api-client/generated/models';
import { REPLACEMENT_TEXT } from '@/constants';
import { useGacha } from '@/hooks/context/GachaContext';
import { createApiClientWithToken } from '@/service/PreRegistrationApiFactory';

interface FormValues {
  title: string;
  body: string;
  targetOs: TargetOs;
}

const SendEmailPage: React.FC = () => {
  const { gacha } = useGacha();
  const history = useHistory();

  const [isSendingMail, setIsSendingMail] = useState(false);

  const api = createApiClientWithToken();

  const onFinish = async (values: FormValues) => {
    if (typeof gacha.id === 'undefined') return;
    setIsSendingMail(true);

    await api
      .sendEmail(gacha.id, {
        body: {
          title: values.title,
          body: values.body,
          targetOs: values.targetOs,
        },
      })
      .then(() => {
        notification.success({
          message: 'メールの送信に成功しました',
        });
        setTimeout(() => history.push(`/gacha/${gacha.id}`), 500);
      })
      .catch(() => {
        notification.error({
          message: 'メールの送信に失敗しました',
          description: `エンジニアまで確認をお願いします。ガチャID: ${gacha.id}`,
        });
      });
    setIsSendingMail(false);
  };

  return (
    <Card title={<Typography.Title level={4}>メール送信画面</Typography.Title>}>
      <Form onFinish={onFinish} labelCol={{ span: 5 }} wrapperCol={{ span: 14 }}>
        <Form.Item label="メールの件名" name="title" rules={[{ required: true, message: '件名を入力してください' }]}>
          <Input disabled={isSendingMail} />
        </Form.Item>

        <Form.Item
          label="メールの本文"
          name="body"
          rules={[{ required: true, message: '本文を入力してください' }]}
          extra={
            <div>
              【置換文字】
              <br />
              {REPLACEMENT_TEXT.NICKNAME} ：登録者のユーザ名
              <br />
              {REPLACEMENT_TEXT.MAIL_ADDRESS} ：登録者のメアド
              <br />
              {REPLACEMENT_TEXT.GAME} ：ガチャのゲームタイトル
              <br />
              {REPLACEMENT_TEXT.DOWNLOAD_URL} ：ゲームのダウンロードURL
            </div>
          }
        >
          <Input.TextArea rows={10} disabled={isSendingMail} />
        </Form.Item>

        <Form.Item
          name="targetOs"
          label="送信対象OS"
          rules={[{ required: true, message: '送信対象のOSを選択してください' }]}
        >
          <Select style={{ maxWidth: '200px' }} disabled={isSendingMail}>
            <Select.Option value="all">全て</Select.Option>
            <Select.Option value="ios">iOS</Select.Option>
            <Select.Option value="android">Android</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 5, span: 14 }}>
          <Button type="primary" htmlType="submit">
            送信
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default SendEmailPage;
